export default __webpack_public_path__ + "static/media/grass.d40df956.svg";